module.exports = __webpack_public_path__ + "img/logo.bcbb8745.png";